import React from 'react';
import scrollTo from '../utils/scrollTo';
import breakpoints from '../config/breakpoints';
import classNames from 'classnames';
import findVariantById from '../utils/findVariantById';
import app from '../utils/app';

const HEADER_HEIGHT = 80;

const scrollToDetails = event => {
	const reviewsContainer = document.getElementById('details');
	const responsiveGutter = (window.innerWidth >= breakpoints.md ? 120 : 60);

	if (!reviewsContainer) return;

	event.preventDefault();

	scrollTo(reviewsContainer.offsetTop - HEADER_HEIGHT - responsiveGutter);
};

export default ({
	brandName,
	isAddingItem,
	addItemAndOpenCart,
	inventoryProduct,
	productId,
	variantId,
	priceMatchCta,
	notifyMeCta,
}) => {
	let activeInventoryVariant = inventoryProduct.variants[0];

	if (inventoryProduct.variants && inventoryProduct.variants.length > 1 && variantId) {
		activeInventoryVariant = findVariantById(inventoryProduct.variants, variantId);
	}

	const onSubmit = event => {
		event.preventDefault();

		// Track add to cart
		if (app.analytics) {
			app.analytics.addToCart({
				id: activeInventoryVariant.sku,
				name: inventoryProduct.title,
				brand: brandName,
				category: 'Watches',
				variant: activeInventoryVariant.title,
				quantity: 1,
				price: Number(activeInventoryVariant.price),
			});
		}

		addItemAndOpenCart([{
			variantId: activeInventoryVariant.id,
			quantity: 1,
		}]);
	};

	return (
		<form onSubmit={onSubmit}>
			<div className="show--md">
				<ul className="list list--horizontal list--forward gutter--none">
					{activeInventoryVariant && !activeInventoryVariant.available ? (
						<React.Fragment>
							<li className="list__item pr2">
								<button
									disabled
									title='Out of Stock'
									type='button'
									className='button--primary-black min-width'>
									Out of Stock
								</button>
							</li>
							<li className="list__item">
							{notifyMeCta ? (
								<a
									className='db min-width button--secondary'
									target={notifyMeCta.openInNewWindow ? '_blank': null}
									rel={notifyMeCta.openInNewWindow ? 'noreferrer noopener': null}
									title={notifyMeCta.title}
									href={notifyMeCta.url}>
									{notifyMeCta.title}
								</a>
							) : (
								<a
									href="#details"
									onClick={scrollToDetails}
									type="button"
									name="details"
									className="db min-width button--secondary">
									View Details
								</a>
							)}
							</li>
						</React.Fragment>
					) : (
						<React.Fragment>
							<li className="list__item pr2">
								<button
									disabled={isAddingItem}
									title="Add to Bag"
									name="add"
									type="submit"
									className={classNames('db min-width button--primary-black', {
										loading: isAddingItem,
									})}>
									{isAddingItem ? 'Adding…' : 'Add to Bag'}
								</button>
							</li>
							<li className="list__item">
								{priceMatchCta ? (
									<a
										className="db min-width button--secondary"
										target={priceMatchCta.openInNewWindow ? '_blank': null}
										rel={priceMatchCta.openInNewWindow ? 'noreferrer noopener': null}
										title={priceMatchCta.title}
										href={priceMatchCta.url}>
										{priceMatchCta.title}
									</a>
								) : (
									<a
										href="#details"
										onClick={scrollToDetails}
										type="button"
										name="details"
										className="db min-width button--secondary">
										View Details
									</a>
								)}
							</li>
						</React.Fragment>
					)}
				</ul>
			</div>
			<div className="hide--md">
				{activeInventoryVariant && !activeInventoryVariant.available ? (
					<React.Fragment>
						<div className="mb2">
							<button
								disabled
								title='Out of Stock'
								type='button'
								className='button--primary-black full-width'>
								Out of Stock
							</button>
						</div>

						{notifyMeCta ? (
							<a
								className='db min-width button--secondary'
								target={notifyMeCta.openInNewWindow ? '_blank': null}
								rel={notifyMeCta.openInNewWindow ? 'noreferrer noopener': null}
								title={notifyMeCta.title}
								href={notifyMeCta.url}>
								{notifyMeCta.title}
							</a>
						) : (
							<a
								href="#details"
								onClick={scrollToDetails}
								type="button"
								name="details"
								className="db min-width button--secondary">
								View Details
							</a>
						)}
					</React.Fragment>
				) : (
					<React.Fragment>
						<div className="mb2">
							<button
								disabled={isAddingItem}
								type="submit"
								title="Add to Bag"
								name="add"
								className={classNames('full-width button--primary-black', {
									loading: isAddingItem
								})}>
								{isAddingItem ? 'Adding…' : 'Add to Bag'}
							</button>
						</div>
						{priceMatchCta ? (
							<a
								className="full-width button--secondary"
								target="_blank"
								title={priceMatchCta.title}
								href={priceMatchCta.url}>
								{priceMatchCta.title}
							</a>
						) : (
							<a
								href="#details"
								onClick={scrollToDetails}
								type="button"
								name="details"
								className="full-width button--secondary">
								View Details
							</a>
						)}
					</React.Fragment>
					)}

			</div>
		</form>
	);
};